function countdown( elementName, minutes, seconds ){
    var element, endTime, hours, mins, msLeft, time;
    function twoDigits( n ) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if ( msLeft < 1000 ) {
            element.innerHTML = "Time is up!";
        } else {
            time = new Date( msLeft );
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            element.innerHTML = (hours ? hours + ':' + twoDigits( mins ) : mins) + ':' + twoDigits( time.getUTCSeconds() );
            setTimeout( updateTimer, time.getUTCMilliseconds() + 500 );
        }
    }

    element = document.getElementById( elementName );
    endTime = (+new Date) + 1000 * (60*minutes + seconds) + 500;
    updateTimer();
}
 
$('document').ready(function(){
  $("[data-modal]").on('click', function(){
     var modalID = $(this).attr("data-modal");
     $('.custom-modal#'+modalID).addClass('show');
  });
  
  $('.custom-modal__close').on('click', function(){
    $(this).parents('.custom-modal').removeClass('show');
  });
});

jQuery('.order--product').click(function(e){
  e.preventDefault();
  let productID = jQuery('.order--product-ID').val();
  if(productID){
     $.ajax({
          type: 'POST',
          url: window.Shopify.routes.root + 'cart/add.js',
          dataType: 'json',
          data: {'id': productID, 'quantity': 1 },
          success: function (response) {
              console.log('Success:', response);               
              window.location.href = '/checkout?express';
          },
          error: function (xhr, status, error) {
              console.error('Error:', error);
          }
      });
  }
  });
jQuery(document).ready(function(){
  if(jQuery('body').hasClass('product')){   
        jQuery('#prvw__bundle_container').hide();
        var groupedQuantity = jQuery('#prvw__bundle_container').html();
        if(groupedQuantity){
          jQuery('.product-form__buttons_new').before('<div class="prvw__bundle_container">'+groupedQuantity+'</div>');
        }      

       jQuery('.block__cbwrapper .block__cb input#cb1').attr('checked',true);      
       jQuery('.block__cbwrapper .block__cb label').on('click',function(e){
          jQuery('.block__cbwrapper .block__cb input').removeAttr('checked');
          jQuery(this).parent().find('input').attr('checked',true);
        });

        jQuery('label.ROS-radio-button-click-target-3').on('click',function(){
            jQuery('.prvw__bundle_container').addClass('content-disabled');
        });

function countdownByClass(className, hours, minutes, seconds) {
    var elements = document.getElementsByClassName(className);
    if (elements.length === 0) {
        console.error("Element with class '" + className + "' not found.");
        return;
    }

    var endTime, hours, mins, msLeft, time;

    function twoDigits(n) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if (msLeft < 1000) {
            for (var i = 0; i < elements.length; i++) {
               document.getElementById('countdown-container').style.display='none';
            }
        } else {
            time = new Date(msLeft);
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            var timeString = (hours ? hours + 'h ' + twoDigits(mins) : mins) + 'm ' + twoDigits(time.getUTCSeconds()) + 's';

            for (var i = 0; i < elements.length; i++) {
                elements[i].innerHTML = timeString;
            }

            setTimeout(updateTimer, 1000);
        }
    }

    endTime = (+new Date) + 1000 * (3600 * hours + 60 * minutes + seconds);
    updateTimer();
}
  
  countdownByClass("countdown", 6, 0, 0);
  const deliveryDate = new Date();
  const threeDaysLater = deliveryDate.getDate() + 3;
  deliveryDate.setDate(threeDaysLater)
  const options = { weekday: 'long', month: 'long', day: 'numeric'};
  const formattedDate = deliveryDate.toLocaleDateString('en-US', options);
  document.querySelectorAll('.daycount').forEach(element => {
      element.innerText = formattedDate;
  });

    
  }
});


// Check if .product exists in the DOM
if (document.querySelector('.product')) {
  // Select all the elements you want to wrap
  const elementsToWrap = document.querySelectorAll('variant-selects, .product--description, .product-form__quantity, .product__package-choose, .delivery-content, .product-keyfeatures'); 

  if (elementsToWrap.length > 0) {
    // Create a new wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-wrapper'; // add a class if you want

    // Insert the wrapper before the first element
    const firstElement = elementsToWrap[0];
    firstElement.parentNode.insertBefore(wrapper, firstElement);

    // Move all selected elements into the wrapper
    elementsToWrap.forEach(el => {
      wrapper.appendChild(el);
    });
  }
}


// Custom js

document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper(".hpslider", {
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });

    var swiper = new Swiper(".related_pdp", {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".next-btn",
        prevEl: ".prev-btn",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });


    var swiper = new Swiper(".thumbslider", {
      spaceBetween: 10,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
            breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1366: {
          slidesPerView: 5,
          spaceBetween: 58,
        },
      },
    });
    var swiper2 = new Swiper(".reviewslider", {
      spaceBetween: 10,
            autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      thumbs: {
        swiper: swiper,
      },
    });

function setupFooterMenus() {
  const blocks = document.querySelectorAll('.footer-block--menu');

  blocks.forEach(block => {
    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    // Remove inline styles and classes if switching to desktop
    if (window.innerWidth >= 750) {
      content.style.height = 'auto';
      content.classList.remove('open');
      return;
    }

    // Only run toggle behavior on mobile
    heading.addEventListener('click', () => {
      const isOpen = content.classList.toggle('open');
      if (isOpen) {
        content.style.height = content.scrollHeight + 'px';
        block.classList.add('active');
      } else {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
        });
        block.classList.remove('active');
      }
    });

    // Reset height to auto after transition
    content.addEventListener('transitionend', () => {
      if (content.classList.contains('open')) {
        content.style.height = 'auto';
      }
    });
  });
}

// Initialize on load
setupFooterMenus();

// Re-run if screen is resized (e.g., rotate phone or resize browser)
window.addEventListener('resize', () => {
  setupFooterMenus();
});

// // Check if .product exists in the DOM
// if (document.querySelector('.product')) {
//   // Select all the elements you want to wrap
//   const elementsToWrap = document.querySelectorAll('variant-selects, .product--description, .product-form__quantity, .product__package-choose, .delivery-content'); 

//   if (elementsToWrap.length > 0) {
//     // Create a new wrapper div
//     const wrapper = document.createElement('div');
//     wrapper.className = 'custom-wrapper'; // add a class if you want

//     // Insert the wrapper before the first element
//     const firstElement = elementsToWrap[0];
//     firstElement.parentNode.insertBefore(wrapper, firstElement);

//     // Move all selected elements into the wrapper
//     elementsToWrap.forEach(el => {
//       wrapper.appendChild(el);
//     });
//   }
// }

// Base settings
// var flkty = new Flickity('.ShopTheLook', {
//   prevNextButtons: false,
//   pageDots: false,
//   draggable: (document.querySelectorAll('.ShopTheLook__Item').length === 1) ? false : true,
//   cellAlign: 'center',
//   wrapAround: false,
//   percentPosition: false,
//   dragThreshold: 10,
//   cellSelector: '.ShopTheLook__Item',
//   arrowShape: {
//     x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25
//   }
// });

// // Breakpoint logic (lap-and-up)
// function updateFlickityForBreakpoint() {
//   if (window.matchMedia('(min-width: 1024px)').matches) {
//     flkty.options.prevNextButtons = true;
//     flkty.options.draggable = false;
//     flkty.options.wrapAround = true;
//   } else {
//     flkty.options.prevNextButtons = false;
//     flkty.options.draggable = (document.querySelectorAll('.ShopTheLook__Item').length === 1) ? false : true;
//     flkty.options.wrapAround = false;
//   }

//   flkty.resize(); // re-render with new settings
// }

// // Run on load + resize
// updateFlickityForBreakpoint();
// window.addEventListener('resize', updateFlickityForBreakpoint);


// // Inner Product slider

// document.querySelectorAll('.ShopTheLook__ProductList').forEach(function(list){
//   new Flickity(list, {
//     prevNextButtons: false,
//     pageDots: list.querySelectorAll('.ShopTheLook__ProductItem').length > 1,
//     draggable: list.querySelectorAll('.ShopTheLook__ProductItem').length > 1, // enable drag
//     wrapAround: true,
//     contain: true,
//     cellAlign: 'center',
//     freeScroll: false,
//     cellSelector: '.ShopTheLook__ProductItem'
//   });
// });







});


// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll('.ShopTheLook').forEach(section => {

//     const productSlider = section.querySelector('.ShopTheLook__ProductList');
//     const dots = section.querySelectorAll('.ShopTheLook__Dot');
//     const items = section.querySelectorAll('.ShopTheLook__ProductItem');

//     if (!productSlider || items.length === 0 || dots.length === 0) return;

//     let current = 0;

//     // Move slider
//     function goToSlide(index) {
//       current = index;
//       const offset = items[index].offsetLeft;

//       productSlider.scrollTo({
//         left: offset,
//         behavior: "smooth"
//       });

//       updateDots(index);
//     }

//     // Dot UI update
//     function updateDots(index) {
//       dots.forEach(dot => dot.classList.remove("is-active"));
//       if (dots[index]) dots[index].classList.add("is-active");
//     }

//     // Dot click scrolls slider
//     dots.forEach((dot, index) => {
//       dot.addEventListener("click", () => goToSlide(index));
//     });

//     // Update dot based on scroll
//     productSlider.addEventListener("scroll", () => {
//       let newIndex = 0;
//       let minDist = Infinity;

//       items.forEach((item, i) => {
//         const dist = Math.abs(item.offsetLeft - productSlider.scrollLeft);
//         if (dist < minDist) {
//           minDist = dist;
//           newIndex = i;
//         }
//       });

//       if (newIndex !== current) {
//         current = newIndex;
//         updateDots(newIndex);
//       }
//     });

//     // Initial
//     updateDots(0);
//   });
// });

document.addEventListener("DOMContentLoaded", () => {

  /* -----------------------------
      OUTER LOOK SLIDER (Flickity)
  ------------------------------ */
  const shopTheLookCarousel = document.querySelector('.ShopTheLook');

  // Guard pages that do not include the Shop The Look component to avoid
  // undefined Flickity instances.
  if (shopTheLookCarousel) {
    var flkty = new Flickity(shopTheLookCarousel, {
      prevNextButtons: true,
      pageDots: false,
      draggable: (document.querySelectorAll('.ShopTheLook__Item').length === 1) ? false : true,
      cellAlign: 'center',
      // wrapAround: false,
      percentPosition: false,
      dragThreshold: 10,
      wrapAround: true,
      cellSelector: '.ShopTheLook__Item',
      arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 }
    });

    function updateFlickityForBreakpoint() {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        flkty.options.prevNextButtons = true;
        flkty.options.draggable = false;
        flkty.options.wrapAround = true;
      } else {
        flkty.options.prevNextButtons = false;
        flkty.options.draggable =
          (document.querySelectorAll('.ShopTheLook__Item').length === 1) ? false : true;
        flkty.options.wrapAround = false;
      }
      flkty.resize();
    }


    updateFlickityForBreakpoint();
    setTimeout(() => {
      updateFlickityForBreakpoint();
    }, 500);
    window.addEventListener('resize', updateFlickityForBreakpoint);


    /* -------------------------------------------
        INNER PRODUCT SLIDERS (Flickity per Look)
    -------------------------------------------- */
    const innerSliders = [];

    document.querySelectorAll('.ShopTheLook__ProductList').forEach(function(list){
      const inner = new Flickity(list, {
        // pageDots is set based on slide count to avoid useless dots on single item
        pageDots: list.querySelectorAll('.ShopTheLook__ProductItem').length > 1,
        draggable: list.querySelectorAll('.ShopTheLook__ProductItem').length > 1,
        wrapAround: true,
        contain: true,
        cellAlign: 'center',
        freeScroll: false,
        cellSelector: '.ShopTheLook__ProductItem'
      });

      innerSliders.push(inner);
    });
  }


  /* -------------------------
       DOT CLICK FUNCTIONALITY
  ------------------------- */
//   document.querySelectorAll('.ShopTheLook').forEach((section, lookIndex) => {

//   const dots = section.querySelectorAll('.ShopTheLook__Dot');
//   const innerSlider = innerSliders[lookIndex];

//   if (!dots.length || !innerSlider) return;

//   function updateDots(index) {
//     dots.forEach(dot => dot.classList.remove("is-active"));
//     const activeDot = section.querySelector(`.ShopTheLook__Dot[data-product-index="${index}"]`);
//     if (activeDot) activeDot.classList.add("is-active");
//   }

//   dots.forEach(dot => {
//     dot.addEventListener("click", () => {
//       const index = Number(dot.dataset.productIndex); // ← FIXED
//       innerSlider.select(index);
//       updateDots(index);
//     });
//   });

//   innerSlider.on('change', index => updateDots(index));

//   updateDots(0);
// });


});

/* 
document.addEventListener("DOMContentLoaded", () => {

  const isMobile = window.matchMedia("(max-width: 1023px)").matches;

  document.querySelectorAll(".ShopTheLook__Dot").forEach(dot => {
    dot.addEventListener("click", (e) => {

      if (isMobile) {
        // MOBILE → go to product page
        const url = dot.dataset.productUrl;
        if (url) window.location.href = url;
      } 
      // DESKTOP → your existing JS handles slide change
    });
  });

});
 */

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(
    ".multicolumn.home_new_multicolumn .multicolumn-list.grid"
  );

  if (!container) return;

  const items = container.querySelectorAll(".multicolumn-list__item");
  if (!items.length) return;

  // Add swiper class
  container.classList.add("swiper");

  // Create wrapper
  const wrapper = document.createElement("div");
  wrapper.classList.add("swiper-wrapper");

  items.forEach((item) => {
    item.classList.add("swiper-slide");
    wrapper.appendChild(item);
  });

  container.innerHTML = "";
  container.appendChild(wrapper);

  // Add arrow wrapper ONLY if more than 1 slide
  if (items.length > 1) {
    const arrowsWrapper = document.createElement("div");
    arrowsWrapper.className = "swiper-button-wrapper";

    const prevArrow = document.createElement("div");
    prevArrow.className = "swiper-button-arrow swiper-button-prev";

    const nextArrow = document.createElement("div");
    nextArrow.className = "swiper-button-arrow swiper-button-next";

    arrowsWrapper.appendChild(prevArrow);
    arrowsWrapper.appendChild(nextArrow);

    container.appendChild(arrowsWrapper);
  }

  // Initialize Swiper
  if (items.length > 1) {
    const swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: "auto",
        },
      },
    });

    console.log("Swiper Initialized:", swiper);
  }
});
